import { Dimensions } from 'react-native';

const width = Dimensions.get('window').width;
const height = Dimensions.get('window').height;

export const WITH_CONTENT = '1050px';

export default {
  window: {
    width,
    height,
  },
  isSmallDevice: width < 375,
};
